import { GroupsFeedScreen, GroupsFeedScreenLoggedOut } from 'app/features/group/screens'
import { withAuthedPage } from 'lib/session'
import { GetServerSideProps } from 'next'
import { GroupNavCarousel } from 'app/features/group/components'
import { addApolloState, initializeApollo } from 'lib/initialize-apollo'
import {
  userFeedQuery,
  hotGroupsQuery,
} from 'app/features/group/screens/groups-feed-screen/queries'
import { useAuth } from 'app/provider/auth'
import { userGroupsQuery } from 'app/features/group/queries'

export default function Page() {
  const { user } = useAuth()

  if (!!user) {
    return <GroupsFeedScreen HeaderComponent={<GroupNavCarousel />} />
  }

  return <GroupsFeedScreenLoggedOut HeaderComponent={<GroupNavCarousel />} />
}

export const getServerSideProps: GetServerSideProps = withAuthedPage(async ({ req }) => {
  const user = req?.session?.user
  const client = initializeApollo({ token: user?.token })

  if (!user) {
    await client.query({
      query: hotGroupsQuery.query,
      variables: hotGroupsQuery.defaultVariables,
    })
  }

  if (user) {
    await client.query({
      query: userGroupsQuery.query,
      variables: {
        ...userGroupsQuery.defaultVariables,
      },
    })

    await client.query({
      query: userFeedQuery.query,
      variables: {
        ...userFeedQuery.defaultVariables,
      },
    })
  }

  return addApolloState(client, {
    props: {
      user: user || null,
    },
  })
})
